import React from 'react';

import { type BreadcrumbItem, Breadcrumbs, Text } from '@ekhodealer/ekho-common/rev';

import './PageLayoutHeader.scss';

export interface PageLayoutHeaderProps {
	title?: string;
	breadcrumb?: {
		items: BreadcrumbItem[];
		currentId?: string | number;
	};
	size?:
		| 'display300'
		| 'display200'
		| 'display100'
		| 'title300'
		| 'title200'
		| 'title100'
		| 'heading'
		| 'body'
		| 'bodySmall'
		| 'footnote'
		| 'caption';
	trailingContent?: React.ReactNode;
}

export const PageLayoutHeader: React.FC<PageLayoutHeaderProps> = ({
	title,
	breadcrumb,
	size = 'heading',
	trailingContent,
}) => {
	return (
		<div className='page-layout-header'>
			<div className='page-layout-header__leading'>
				{breadcrumb ? (
					<Breadcrumbs items={breadcrumb.items} currentId={breadcrumb.currentId} />
				) : (
					<Text size={size} weight='bold'>
						{title}
					</Text>
				)}
			</div>
			{trailingContent && (
				<div className='page-layout-header__trailing'>{trailingContent}</div>
			)}
		</div>
	);
};
